






































































































































import Vue from 'vue'

export default Vue.extend({
  scrollToTop: true,
  data() {
    return {
      cards: [
        {
          img: require('../assets/phpExpressLogo.webp'),
          link: 'https://github.com/devxian96/phpExpress',
          summary: 'PHP RestAPI 프레임워크',
        },
        {
          img: require('../assets/neomo.webp'),
          link: 'https://github.com/neomorphism/neomo',
          summary: '뉴모피즘 웹 디자인 프레임워크',
        },
      ],
      frontEnd: [
        {
          icon: 'fab fa-vuejs',
          summary: 'vue.js (Nuxt.js, Vuex)',
        },
        {
          icon: 'fab fa-react',
          summary: 'react (Next.js, Redux)',
        },
        {
          icon: 'fab fa-js-square',
          summary: 'ES6 이상',
        },
        {
          icon: 'fab fa-html5',
          summary: 'HTML5 (DOM, Repaint, Reflow)',
        },
        {
          icon: 'fab fa-css3',
          summary: 'css3 (Triger, Module)',
        },
        {
          icon: 'fas fa-cube',
          summary: 'Webpack',
        },
        {
          icon: 'fas fa-bold',
          summary: 'Babel',
        },
        {
          icon: 'fas fa-poll',
          summary: 'Polyfill',
        },
        {
          icon: 'fas fa-check',
          summary: 'Typescript',
        },
        {
          icon: 'fab fa-bootstrap',
          summary: 'Bootstrap (Vuetify)',
        },
        {
          icon: 'fab fa-mdb',
          summary: 'Material UI',
        },
      ],
      backEnd: [
        { icon: 'fab fa-node', summary: 'node.js (Express, http, ejs)' },
        { icon: 'fab fa-php', summary: 'PHP5,7' },
        {
          icon: 'fab fa-java',
          summary:
            'Spring MVC, Spring Boot (thymeleaf, jpa, mybatis, 전자정부프레임워크)',
        },
        {
          icon: 'fab fa-python',
          summary: 'Flask (TF, Keras, Orion)',
        },
        {
          icon: 'fas fa-database',
          summary: 'RDBMS(MySQL, Oracle, PostgreSQL), TSDBMS(influxDB)',
        },
      ],
      devOps: [
        {
          icon: 'fab fa-aws',
          summary: 'EC2, RDB, Route53, lightsail',
        },
        {
          icon: 'fas fa-server',
          summary:
            'VPS (Hostinger, Vultr...), Cloud (FireBase, Github Page, Vercel)',
        },
        {
          icon: 'fab fa-slack',
          summary: 'Slack, notion',
        },
        {
          icon: 'fab fa-git',
          summary: 'GIT 형상관리도구',
        },
        {
          icon: 'fab fa-windows',
          summary: 'Windows Server (구축, 최적화)',
        },
        {
          icon: 'fab fa-linux',
          summary: 'Linux Server (구축, 최적화)',
        },
      ],
      elseSkill: [
        {
          icon: 'fas fa-scroll',
          summary: '사무자동화(Autoit)',
        },
        {
          icon: 'fas fa-shield-alt',
          summary: '모의침투테스팅',
        },
        {
          icon: 'fas fa-code',
          summary: 'C, C#',
        },
      ],
    }
  },
  head() {
    return {
      title: '홈',
    }
  },
})
